export default __webpack_public_path__ + "static/media/line1.39c57211.svg";